import React, { FC, ReactNode, useCallback, useState } from 'react';
import { Button, Card, CardBody, CardText, CardTitle, Col, Row } from 'reactstrap';
import { useTranslation } from '../translations';
import { MaterialIcon, UserStateComponent } from '.';

export const PIIAccessWarning: FC<{
  readonly children: ReactNode;
  readonly onConfirm: () => void;
}> = ({ children, onConfirm }) => {
  const { ts } = useTranslation();
  const [renderChildren, setRenderChildren] = useState(false);

  const requestPII = useCallback(() => {
    onConfirm();
    setRenderChildren(true);
  }, [onConfirm, setRenderChildren]);

  if (renderChildren) {
    return children;
  }

  return (
    <UserStateComponent>
      <Row className="justify-content-center">
        <Col className="mb-10" xs={12}>
          <Card className="warning">
            <CardBody className="text-center">
              <MaterialIcon large name="warning" type="warning" />
              <CardTitle>{ts('pii_access_warning.pii_access_warning')}</CardTitle>
              <CardText>{ts('pii_access_warning.you_are_attempting_to_access')}</CardText>
              <CardText>{ts('pii_access_warning.you_are_required_to_confirm')}</CardText>
              <CardText>{ts('pii_access_warning.this_access_will_be_logged')}</CardText>
            </CardBody>
          </Card>
        </Col>
        <Col lg={6} xs={12}>
          <Button block color="danger" id="accessEmergencyContactsBtn" onClick={requestPII}>
            {ts('common.continue')}
          </Button>
        </Col>
      </Row>
    </UserStateComponent>
  );
};
